import axios from "axios"
import dispatcher from "./dispatcher"

// TODO: use Promises
import * as querystring from "querystring";
import globalStore from "./stores/GlobalStore";

export function doApiCall(endpoint, data, done, quiet=false, onError?){
    const config = { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } , withCredentials : true};

    post(endpoint, querystring.stringify(data), config, done, quiet, onError);
}

export function doGetApiCall(endpoint, done, quiet=false, onError?){
    const config = { headers: {} , withCredentials : true};

    nodata(endpoint, config, done, quiet, onError);
}

export function doJsonApiCall(endpoint, data, done, quiet=false, onError?){
    const config = { headers: { 'Content-Type': 'application/json' } , withCredentials : true};

    post(endpoint, JSON.stringify(data), config, done, quiet, onError);
}

export function doJsonGetApiCall(endpoint, done, quiet=false, onError?){
    const config = { headers: { 'Content-Type': 'application/json' } , withCredentials : true};

    nodata(endpoint, config, done, quiet, onError);
}

export function doJsonDeleteApiCall(endpoint, done, quiet=false, onError?){
    const config = { headers: { 'Content-Type': 'application/json' } , withCredentials : true};

    nodata(endpoint, config, done, quiet, onError, axios.delete);
}


export function doApiCallWithSingleFile(endpoint, data, done, quiet=false, onError?){
    let allData = new FormData();

    for(var item in data){
        allData.append(item, data[item]);
    }
    if(data.file){
        allData.append('file', data.file, data.file.name);
    }

    const config = {
        headers: { 'content-type': 'multipart/form-data' }
    };

    post(endpoint, allData, config, done, quiet, onError);
}

export function doApiCallWithMultipleFiles(endpoint, data, done, quiet=false, onError?){
    let allData = new FormData();
    let fileList = data.files;
    
    let fileIndex = 0;
    for (const file of fileList){
        allData.append("file"+ fileIndex, file, file.name);
        fileIndex++;
    }
    allData.append("fileCount", String(fileIndex));

    for(var item in data){
        if(item != 'files'){
            allData.append(item, data[item]);
        }
    }

    const config = {
        headers: { 'content-type': 'multipart/form-data' }
    };

    post(endpoint, allData, config, done, quiet, onError);
}

function post(endpoint, allData, config, done, quiet, onError){
    axios.post(globalStore.getHost() + "/api/" + endpoint, allData, config)
        .then((result: any) => {
            result = result.data;
            if(result._status == 1){
                done(result);
            }else{
                if(quiet == false) {
                    dispatcher.dispatch({
                        type: "NOTIFICATION",
                        title: "Oops",
                        message: result.message
                    })
                }
                if(onError !== undefined){
                    onError();
                }
            }
        })
        .catch((error) => {
            if(quiet == false){
                dispatcher.dispatch({
                    type: "NOTIFICATION",
                    title: "Oops",
                    message:"Could not communicate with server. [" + endpoint + "]"
                })
            }
            if(onError !== undefined){
                onError(error);
            }
        })
}

function nodata(endpoint, config, done, quiet, onError, method = axios.get){
    method(globalStore.getHost() + "/api/" + endpoint, config)
        .then((result: any) => {
            result = result.data;
            if(result._status == 1){
                done(result);
            }else{
                if(quiet == false) {
                    dispatcher.dispatch({
                        type: "NOTIFICATION",
                        title: "Oops",
                        message: result.message
                    })
                }
                if(onError !== undefined){
                    onError();
                }
            }
        })
        .catch((error) => {
            if(quiet == false){
                dispatcher.dispatch({
                    type: "NOTIFICATION",
                    title: "Oops",
                    message:"Could not communicate with server. [" + endpoint + "]"
                })
            }
            if(onError !== undefined){
                onError(error);
            }
        })
}